<template>
    <li>
        <span class="label">{{$t(label)}}</span>：
        <slot>
            <incognito v-if="isShow && value"
                       :sensitiveData="value"
                       :type='type' />
            <span class="overflowd"
                  v-else>{{value || '--'}}</span>
        </slot>
    </li>
</template>

<script>
export default {
    name: 'DetailItem', // 表格类详细信息项
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number]
        }
    },
    computed: {
        isShow () {
            return this.isName || this.label === '管理员手机' || this.label === '管理员邮箱' || this.label === '电话' || this.label === '邮箱' || this.label === '订购人电话' || this.label === '收件人电话'
        },
        isName () {
            const itemNames = ['姓名', '用户名']
            return itemNames.includes(this.label)
        },
        type () {
            return this.isName ? 'name' : null
        }
    }
}
</script>
<style lang="less" scoped>
.overflowd {
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
